import React from 'react';
import { Check } from 'iconoir-react';
import { formatDateTime } from './trackingUtils';

export const TrackingHistory = ({ historial = [] }) => (
    <section className="bg-white border border-colorfifth rounded-xl p-4 md:p-5 text-left">
        <h6 className="font-semibold text-colorfourth text-left mb-4">Historial de actividades</h6>
        {historial.length === 0 ? (
            <p className="text-sm text-gray-400">Aún no hay actividades registradas.</p>
        ) : (
            <ol className="relative">
                <div className="absolute left-[13px] top-4 bottom-4 w-0.5 bg-colorfifth" />
                {/* La API entrega los eventos en orden cronológico */}
                {historial.map((event, i) => (
                    <li key={`${event.code}-${i}`} className="relative pl-11 mb-4 last:mb-0 text-left">
                        <div className="absolute left-0 top-1 w-7 h-7 rounded-full bg-colorprimarygreen flex items-center justify-center ring-4 ring-white">
                            <Check width={16} height={16} color="#fff" />
                        </div>
                        <div className="text-sm font-semibold text-colorfourth">{event.title}</div>
                        {event.description && <div className="text-sm text-gray-500">{event.description}</div>}
                        {event.date && <div className="text-sm text-gray-400 mt-0.5">{formatDateTime(event.date)}</div>}
                    </li>
                ))}
            </ol>
        )}
    </section>
);
